// extracted by mini-css-extract-plugin
module.exports = {"faxDetails":"styles_faxDetails__vAFVv","detailsBorder":"styles_detailsBorder__1jA37"};